export type DelegationFormEditorMode = "structured" | "standard";

export type DelegationFormConfig = {
    id: string;
    title: string;
    description: string;
    officialUrl: string;
    editorMode: DelegationFormEditorMode;
};

export const DELEGATION_FORMS: DelegationFormConfig[] = [
    {
        id: "01-212",
        title: "Nurse Delegation: Referral Form",
        description: "Case and resource manager request plus delegating nurse response.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/word/01-212.docx",
        editorMode: "structured",
    },
    // Temporarily hidden from the UI until the PDF-based 06-200 flow is ready again.
    // {
    //     id: "06-200",
    //     title: "Nurse Delegation: Billing Form",
    //     description: "Track delegation billing details, dates of service, and payment follow-up.",
    //     officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/06-200.pdf",
    //     editorMode: "standard",
    // },
    {
        id: "10-217",
        title: "Credentials and Training Verification",
        description: "Verify the long term care worker credential, training history, and delegator sign-off.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/10-217.pdf",
        editorMode: "standard",
    },
    {
        id: "13-678",
        title: "Instructions for Nursing Task",
        description: "Document delegation consent, task instructions, and shared care expectations.",
        officialUrl: "https://www.dshs.wa.gov/altsa/residential-care-services/nurse-delegation-forms",
        editorMode: "standard",
    },
    {
        id: "13-678-1",
        title: "Consent for Delegation Process",
        description: "Capture resident consent, provider details, and the delegating RN verification.",
        officialUrl: "https://www.dshs.wa.gov/altsa/residential-care-services/nurse-delegation-forms",
        editorMode: "standard",
    },
    {
        id: "13-678A",
        title: "PRN Medication",
        description: "Capture PRN medication delegation details, monitoring steps, and escalation guidance.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/13-678a.pdf",
        editorMode: "standard",
    },
    {
        id: "13-678B",
        title: "Assumption of Delegation",
        description: "Record delegation handoff details when another delegating nurse assumes responsibility.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/13-678b.pdf",
        editorMode: "standard",
    },
    {
        id: "13-680",
        title: "Rescinding Delegation",
        description: "Document when delegation ends, why it ended, and what follow-up is required.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/13-680.pdf",
        editorMode: "standard",
    },
    {
        id: "13-681",
        title: "Change in Medical Orders",
        description: "Track order changes that affect delegated tasks, monitoring, or caregiver directions.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/13-681.pdf",
        editorMode: "standard",
    },
    {
        id: "13-893",
        title: "Request For Additional Unit",
        description: "Prepare and track requests for additional delegation-related units and justification.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/13-893.pdf",
        editorMode: "standard",
    },
    {
        id: "14-484",
        title: "Nursing Visit",
        description: "Summarize nursing visit observations, delegated tasks reviewed, and follow-up actions.",
        officialUrl: "https://www.dshs.wa.gov/sites/default/files/forms/pdf/14-484.pdf",
        editorMode: "standard",
    },
];

export const getDelegationFormConfig = (formCode?: string | null) => {
    if (!formCode) return null;
    return DELEGATION_FORMS.find((form) => form.id === formCode) || null;
};
